<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header common-modal__text-header-flex-none"
      [afTranslate]="'change-password.change-password'">
      _cambiar contraseña
    </span>
  </div>
  <div class="common-modal__content common-modal__content--with-conditions">
    <form class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-password [field]="resetPassword.newPassword"
        [preSelectItem]="resetPassword.newPass"
        (itemSelected)="itemSelected('newPass', $event.newValue)">
      </field-type-password>
      <field-type-password [field]="resetPassword.repeatPassword"
        [preSelectItem]="resetPassword.repeatPass"
        (itemSelected)="itemSelected('repeatPass', $event.newValue)">
      </field-type-password>
    </form>
    <div class="common-modal__container-conditions">
      <div class="common-modal__inner-container-conditions">
        <div class="common-modal__condition-row">
          <i class="common-icon__sm"
            [ngClass]="{'common-icon__sea-green':resetPassword.minimum === 2,
              'common-icon__persian-red':resetPassword.minimum === 1,
              'lf-icon-check-round': resetPassword.minimum === 0,
              'lf-icon-check-round-full': resetPassword.minimum !== 0}">
          </i>
          <p class="common-modal__condition-text"
            [afTranslate]="'change-password.min-8-char'">
          </p>
        </div>
        <div class="common-modal__condition-row">
          <i class="common-icon__sm"
            [ngClass]="{'common-icon__sea-green':resetPassword.maximun === 2,
              'common-icon__persian-red':resetPassword.maximun === 1,
              'lf-icon-check-round': resetPassword.maximun === 0,
              'lf-icon-check-round-full': resetPassword.maximun !== 0  }">
          </i>
          <p class="common-modal__condition-text"
            [afTranslate]="'change-password.max-32-char'">
          </p>
        </div>
        <div class="common-modal__condition-row">
          <i class="common-icon__sm"
            [ngClass]="{'common-icon__sea-green':resetPassword.noSpecialChars === 2,
              'common-icon__persian-red':resetPassword.noSpecialChars === 1,
              'lf-icon-check-round': resetPassword.noSpecialChars === 0 ,
              'lf-icon-check-round-full': resetPassword.noSpecialChars !== 0   }">
          </i>
          <p class="common-modal__condition-text"
            [afTranslate]="'change-password.without-special-characters'">
          </p>
        </div>
      </div>
      <div class="common-modal__condition-row">
        <p class="common-modal__condition-text"
          [afTranslate]="'change-password.info-validate-char'">
        </p>
      </div>
    </div>
  </div>
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="cancel()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">
        _Cancelar
      </span>
    </button>
    <button class="common-button__text"
      (click)="savePassword()">
      <span class="common-button__text-title"
        [afTranslate]="'common.change'">
        _Cambiar
      </span>
    </button>
  </div>
</div>



<!-- <div class="reset-password">
    <div class="common__modal-header-block">
        <i class="lf-icon-lock common__icon-header"></i>
        <span class="common__text-header"
            [afTranslate]="'reset-password.reset-password'">Resetear contraseña</span>
        <i class="lf-icon-close common__icon-close-modal"
            (click)="handleDismiss()"></i>
    </div>
    <field-type-rich-text class="reset-password__info-block"
        [field]="resetPassword.passwordInfo">
    </field-type-rich-text>
    <div class="reset-password__body-form">
      <form class="reset-password__reset-password-form"
        autocomplete="off">
        <field-type-password [field]="resetPassword.oldPassword"
          [preSelectItem]="resetPassword.oldPass"
          (itemSelected)="itemSelected('oldPass', $event.newValue)">
        </field-type-password>
        <field-type-password [field]="resetPassword.newPassword"
          [preSelectItem]="resetPassword.newPass"
          (itemSelected)="itemSelected('newPass', $event.newValue)">
        </field-type-password>
        <field-type-password [field]="resetPassword.repeatPassword"
          [preSelectItem]="resetPassword.repeatPass"
          (itemSelected)="itemSelected('repeatPass', $event.newValue)">
        </field-type-password>
      </form>
    </div>
    <div class="common__buttons-block common__buttons-block--modal">
        <button type="reset"
            class="common__button common__button--clean"
            (click)="cancel()"
            [afTranslate]="'common.cancel'">Cancelar</button>
        <button type="submit"
            class="common__button common__button--active"
            (click)="savePassword()"
            [afTranslate]="'common.save'">Guardar</button>
    </div>
</div> -->
